import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

// Async thunk for contacting
export const contactUs = createAsyncThunk("contact/contactUs", async (formData, { rejectWithValue }) => {
  try {
    const response = await api.contactUs(formData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response ? error.response.data : { error: "Something went wrong" });
  }
});

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    isLoading: false,
    successMessage: null,
    errorMessage: null,
  },
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.successMessage = null;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUs.pending, (state) => {
        state.isLoading = true;
        state.successMessage = null;
        state.errorMessage = null;
      })
      .addCase(contactUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessage = action.payload.success;
      })
      .addCase(contactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload?.error || "Failed to send message";
      });
  },
});

export const { resetState } = contactSlice.actions;
export default contactSlice.reducer;
